<template>
  <div>
    <div class="breadcrumb-area pos-relative w-100">
      <h1>Danh sách việc cần làm</h1>
      <div class="btn-group float-right">
        <DraggableTable
          :naming="$router.name"
          v-model="fieldsTable"
          @change="filterTable = $event"
        />
        <button
          class="font-medium f12 btn btn-outline-secondary"
          v-if="
            this.selectedTicket.length > 0 && dataPermission.includes('CNPS_TICKET_CHANE_ASSIGNEE')
          "
          @click="showModalRequestDevice(selectedTicket)"
        >
          <i class="bx bx-play"></i><span>&nbsp;</span>Chuyển người làm ({{
            this.selectedTicket.length
          }})
        </button>
      </div>
    </div>
    <div class="card p-10 pt-15 b-t-1-869fb229">
      <div class="card-header m-b-10">
        <form class="box-search" @submit.prevent="submitForm">
          <div class="form-group">
            <input
              type="text"
              v-model.trim="search.key"
              data-toggle="tooltip"
              data-placement="top"
              title="Mã ticket, Danh mục công việc, Sản phẩm, Mã tham chiếu, Mã khách hàng, Tên khách hàng, Số điện thoại, Email, Tên người đại diện, Mã workflow"
              class="form-control f12 hc-37 text-search"
              placeholder="Từ khoá"
            />
          </div>
          <div class="form-group">
            <DateRangePicker
              class="w-100"
              :ranges="false"
              v-model="search.createdTime"
              :locale-data="Config.localeData"
            >
              <template v-slot:input="picker">
                <label
                  v-if="picker.startDate && picker.endDate"
                  style="min-width: 13.5em"
                  class="text-center font-size-12 pt-1"
                >
                  {{ picker.startDate | formatDate }} -
                  {{ picker.endDate | formatDate }}
                </label>
                <label v-else style="min-width: 13.5em" class="font-size-12 time-placeholder">
                  TG tạo
                </label>
              </template>
            </DateRangePicker>
          </div>
          <div class="form-group">
            <Select2
              v-model="search.groupCode"
              @change="getListTicketCategory()"
              :options="Config.getSearch(dataGroupCode)"
              placeholder="Nhóm ticket"
            />
          </div>
          <div class="form-group">
            <Select2
              v-model="search.typeCode"
              @change="getListTicketSubCategory()"
              :options="Config.getSearch(dataTypeCode)"
              placeholder="Danh mục ticket"
            />
          </div>
          <div class="form-group">
            <Select2
              v-model="search.subTypeCode"
              :options="Config.getSearch(dataSubTypeCode)"
              placeholder="Tiểu mục ticket"
            />
          </div>
          <div class="form-group">
            <Select2 v-model="search.userId" :options="dataManager" placeholder="Người xử lý" />
          </div>
          <div class="form-group">
            <Select2
              v-model="search.status"
              :options="Config.getSearch(Config.ticketStatus)"
              placeholder="Trạng thái"
            />
          </div>
          <div class="form-group">
            <Select2
              v-model="search.workPriority"
              :options="Config.getSearch(dataPriority)"
              placeholder="Mức ưu tiên"
            />
          </div>
          <div class="form-group">
            <Select2
              v-model="search.workType"
              :options="Config.getSearch(dataWorkType)"
              placeholder="Loại công việc"
            />
          </div>
          <div class="form-group">
            <DateRangePicker
              class="w-100"
              :ranges="false"
              v-model="search.workingStepTime"
              :locale-data="Config.localeData"
            >
              <template v-slot:input="picker">
                <label
                  v-if="picker.startDate && picker.endDate"
                  style="min-width: 13.5em"
                  class="text-center font-size-12 pt-1"
                >
                  {{ picker.startDate | formatDate }} -
                  {{ picker.endDate | formatDate }}
                </label>
                <label v-else style="min-width: 13.5em" class="font-size-12 time-placeholder">
                  Thời hạn bước hiện tại
                </label>
              </template>
            </DateRangePicker>
          </div>
          <div class="form-group">
            <DateRangePicker
              class="w-100"
              :ranges="false"
              v-model="search.ticketDeadline"
              :locale-data="Config.localeData"
            >
              <template v-slot:input="picker">
                <label
                  v-if="picker.startDate && picker.endDate"
                  style="min-width: 13.5em"
                  class="text-center font-size-12 pt-1"
                >
                  {{ picker.startDate | formatDate }} -
                  {{ picker.endDate | formatDate }}
                </label>
                <label v-else style="min-width: 13.5em" class="font-size-12 time-placeholder">
                  Thời hạn ticket
                </label>
              </template>
            </DateRangePicker>
          </div>
          <div class="form-group">
            <Select2
              v-model="search.urgent"
              :options="Config.getSearch(Config.urgent)"
              placeholder="Độ gấp ticket"
            />
          </div>
          <div class="form-group form-group-action">
            <button type="button" class="btn btn-primary hc-37 mr-2 pt-2" @click="submitForm">
              <i class="bx bx-filter-alt"></i><span>&nbsp;</span>Lọc
            </button>
            <button type="button" class="btn btn-outline-light hc-37 mr-2 pt-2" @click="removeForm">
              <i class="bx bx-filter-alt"></i><span>&nbsp;</span>Bỏ lọc
            </button>
          </div>
        </form>
      </div>
      <div class="card-body">
        <div class="tab-content" id="nav-tabContent">
          <div class="p-10">
            Tổng: <strong class="text-primary">{{ pagination.total }}</strong>
            <b-table
              :busy.sync="tbLoading"
              sticky-header
              responsive
              hover
              :items="lists"
              :fields="filterTable"
              :fixed="true"
              :bordered="true"
            >
              <template #table-busy>
                <div class="text-center my-2">
                  <b-spinner class="align-middle"></b-spinner>
                </div>
              </template>
              <template #head(selected)>
                <b-form-checkbox :unchecked-value="0" v-model="selectAll"></b-form-checkbox>
              </template>
              <template #cell(selected)="data">
                <b-form-checkbox
                  class="text-center"
                  v-model="selectedTicket"
                  :value="{
                    ticketId: data.item.ticketInfo.ticketId,
                    activityId: data.item.activityInfo?.activityId,
                    activityName: data.item.activityInfo?.activityName,
                    link: data.item.activityUrl,
                  }"
                ></b-form-checkbox>
              </template>
              <template #cell(index)="data">
                {{ getIndex(data.index) }}
              </template>
              <template #cell(code)="data">
                <p><b>Mã việc:</b> {{ data.item.activityInfo?.activityId }}</p>
                <p><b>Mã luồng:</b> {{ data.item.activityInfo?.processId }}</p>
                <p>
                  <b>Ticket: </b
                  ><u
                    class="c-poiter text-primary"
                    @click="detailTicket(data.item.ticketInfo.ticketId)"
                    >{{ data.item.ticketInfo.ticketCode }}</u
                  >
                </p>
                <p><b>Tham chiếu:</b> {{ data.item.ticketInfo.channelReferenceId }}</p>
              </template>
              <template #cell(name)="data">
                <p class="c-poiter text-primary" @click="detailWork(data.item.activityUrl)">
                  <u>{{ data.item.activityInfo?.activityName }}</u>
                </p>
                <p>({{ data.item.activityInfo?.dateCreated }})</p>
                <p v-if="data.item.ticketInfo.urgent">
                  <span class="badge badge-danger">
                    {{ data.item.ticketInfo.urgent | transformData(Config.urgent) }}
                  </span>
                </p>
              </template>
              <template #cell(merchantInfo)="data">
                <div>
                  <p>
                    <b>Tên:</b>
                    {{
                      data.item.ticketInfo.merchantInfo &&
                      data.item.ticketInfo.merchantInfo.merchantName
                    }}
                  </p>
                  <p>
                    <b>Email:</b>
                    {{
                      data.item.ticketInfo.merchantInfo && data.item.ticketInfo.merchantInfo.email
                    }}
                  </p>
                  <p>
                    <b>Điểm bán:</b>
                    {{
                      data.item.ticketInfo.bizLocation &&
                      data.item.ticketInfo.bizLocation.areaAddress
                    }}
                  </p>
                  <p>
                    <b>Sale phụ trách:</b>
                    {{ data.item.ticketInfo.assignee && data.item.ticketInfo.assignee.email }}
                  </p>
                </div>
              </template>
              <template #cell(type)="data">
                <p><b>Nhóm:</b> {{ data.item.ticketInfo.groupName }}</p>
                <p><b>Danh mục:</b> {{ data.item.ticketInfo.typeName }}</p>
                <p><b>Tiểu mục:</b> {{ data.item.ticketInfo.subTypeName }}</p>
              </template>
              <template #cell(infoManage)="data">
                <p><b>Ưu tiên:</b> {{ data.item.workPriorityText }}</p>
                <p><b>Loại công việc:</b> {{ data.item.workTypeText }}</p>
              </template>
              <template #cell(deadlineTime)="data">
                <p>
                  <b>Bước hiện tại:</b>
                  {{ data.item.workingStepTime | formatDate('HH:mm, DD/MM/YYYY') }}
                </p>
                <p>
                  <b>Ticket:</b> {{ data.item.ticketDeadline | formatDate('HH:mm, DD/MM/YYYY') }}
                </p>
              </template>
              <template #cell(time)="data">
                <p>
                  <b>Tạo ticket:</b>
                  {{ data.item.ticketInfo.createAt | formatDate('HH:mm, DD/MM/YYYY') }}
                </p>
                <p>
                  <b>Hoàn thành:</b>
                  {{ data.item.ticketInfo.completeTime | formatDate('HH:mm, DD/MM/YYYY') }}
                </p>
                <p>
                  <b>Huỷ:</b>
                  {{ data.item.ticketInfo.cancelTime | formatDate('HH:mm, DD/MM/YYYY') }}
                </p>
              </template>
              <template #cell(status)="data">
                <span class="badge" :class="data.item.ticketInfo.status">
                  {{ data.item.ticketInfo.status | transformData(Config.ticketStatus) }}
                </span>
              </template>
              <template #cell(action)="data">
                <b-dropdown class="text-center" variant="outline-light">
                  <b-dropdown-item
                    @click="detail(data.item.ticketInfo.ticketId)"
                    class="dropdown-item"
                    ><span>&nbsp;</span>Chi tiết
                  </b-dropdown-item>
                  <b-dropdown-item
                    @click="
                      showModalRequestDevice([
                        {
                          ticketId: data.item.ticketInfo?.ticketId,
                          activityId: data.item.activityInfo?.activityId,
                          activityName: data.item.activityInfo?.activityName,
                          link: data.item.activityUrl,
                        },
                      ])
                    "
                    class="dropdown-item"
                    v-if="dataPermission.includes('CNPS_TICKET_CHANE_ASSIGNEE')"
                    ><span>&nbsp;</span>Chuyển người làm
                  </b-dropdown-item>
                  <b-dropdown-item @click="detailWork(data.item.activityUrl)" class="dropdown-item"
                    ><span>&nbsp;</span>Xem công việc
                  </b-dropdown-item>
                </b-dropdown>
              </template>
            </b-table>
          </div>
        </div>
        <div class="pagination-bottom">
          <b-pagination
            v-model="search.pageIndex"
            @change="onChangePage"
            :total-rows="pagination.total"
            :per-page="search.pageSize"
            class="fl-right mr-2"
          ></b-pagination>
        </div>
      </div>
    </div>
    <VueLoadingOverlay :active.sync="showLoading" :is-full-page="true"> </VueLoadingOverlay>
    <modalChangeAssignee
      v-if="isShowModalRequestDevice"
      :closeModalRequestDevice="closeModalRequestDevice"
      :dataOption="dataManager"
      :dataId="dataId"
      @updateInfo="updateInfo"
    />
  </div>
</template>

<script>
  import { StaffService } from '@/services/staff.service'
  import { mapGetters } from 'vuex'
  import 'vue-simple-suggest/dist/styles.css'
  import Config from '@/thirdParty/config'
  import moment from 'moment'
  import { TicketService } from '@/services/ticket.service'
  import cloneDeep from 'lodash/cloneDeep'
  import mxItemAction from './mx-item-action.js'
  import modalChangeAssignee from './modal-change-assignee.vue'
  const fieldsTable = [
    { key: 'selected', label: '' },
    { key: 'index', label: 'STT', class: 'text-center' },
    { key: 'name', label: 'Tên công việc', thStyle: 'min-width: 150px' },
    { key: 'merchantInfo', label: 'Merchant', thStyle: 'min-width: 170px' },
    { key: 'type', label: 'Phân loại', thStyle: 'min-width: 150px' },
    { key: 'code', label: 'Mã', thStyle: 'min-width: 250px' },
    { key: 'infoManage', label: 'TT Quản lý', thStyle: 'min-width: 190px' },
    { key: 'deadlineTime', label: 'Thời hạn', thStyle: 'min-width: 190px' },
    { key: 'time', label: 'Thời gian', thStyle: 'min-width: 190px' },
    { key: 'status', label: 'Trạng thái' },
    { key: 'action', label: 'Thao tác', fixIndex: 999, class: 'text-center' },
  ]
  export default {
    name: 'ticket-work',
    mixins: [mxItemAction],
    components: { modalChangeAssignee },
    data() {
      return {
        Config,
        fieldsTable,
        filterTable: fieldsTable,
        lists: [],
        showLoading: false,
        tbLoading: false,
        dataUser: JSON.parse(localStorage.getItem('userData')),
        dataManager: [],
        dataTypeCode: [],
        dataSubTypeCode: [],
        dataGroupCode: [],
        search: {
          status: 'PROCESSING',
          pageSize: 20,
          pageIndex: 1,
          createdTime: {},
          workingStepTime: {},
          ticketDeadline: {},
        },
        pagination: {
          total: 0,
        },
        dataPriority: [],
        dataWorkType: [],
        isShowModalRequestDevice: false,
        dataId: {},
        selectedTicket: [],
      }
    },
    watch: {},
    created() {
      this.search.userId = this.dataUser.userId
      StaffService.getStaffByIdSuperior({ userId: this.dataUser.userId })
        .then(s => s.data?.map(s => ({ id: s.userId, text: `${s.name} - ${s.userName}` })) ?? [])
        .then(s => (this.dataManager = s))
      TicketService.fetchGroup()
        .then(s => s.data?.map(s => ({ id: s.code, text: s.name, mapId: s.id })) ?? [])
        .then(s => (this.dataGroupCode = s))
      TicketService.getListWorkType()
        .then(s => s.data.data)
        .then(s => Object.keys(s).map(key => ({ id: key, text: s[key] })))
        .then(s => (this.dataWorkType = s))
      TicketService.getListPriority()
        .then(s => s.data.data)
        .then(s => Object.keys(s).map(key => ({ id: key, text: s[key] })))
        .then(s => (this.dataPriority = s))
      this.fetchData()
      this.getListTicketCategory()
      this.getListTicketSubCategory()
    },
    computed: {
      selectAll: {
        get: function () {
          return this.lists ? this.selectedTicket.length === this.lists.length : false
        },
        set: function (value) {
          if (value) {
            this.selectedTicket = this.lists?.map(s => ({
              ticketId: s.ticketInfo.ticketId,
              activityId: s.activityInfo?.activityId,
              activityName: s.activityInfo?.activityName,
              link: s.activityUrl,
            }))
          } else if (value === 0) this.selectedTicket = []
        },
      },
      ...mapGetters({
        dataPermission: 'role/dataPermission',
      }),
    },
    methods: {
      detail(id) {
        const routeData = this.$router.resolve({ path: `/ticket/${id}` })
        window.open(routeData.href, '_blank')
      },
      detailWork(url) {
        window.open(url, '_blank')
      },
      async submitForm() {
        this.search.pageIndex = 1
        this.fetchData()
      },
      async removeForm() {
        this.search = {
          pageSize: 20,
          pageIndex: 1,
          createdTime: {
            startDate: null,
            endDate: null,
          },
          workingStepTime: {
            startDate: null,
            endDate: null,
          },
          ticketDeadline: {
            startDate: null,
            endDate: null,
          },
          userId: this.dataUser.userId,
        }
        await this.fetchData()
        await this.getListTicketCategory()
        await this.getListTicketSubCategory()
      },
      preareData() {
        const data = cloneDeep(this.search)
        for (const key in data) {
          if (data[key] === '0') delete data[key]
        }
        if (data.createdTime.endDate) {
          data.createFrom = moment(data.createdTime.startDate).startOf('day').valueOf()
          data.createTo = moment(data.createdTime.endDate).endOf('day').valueOf()
        }
        if (data.workingStepTime.endDate) {
          data.workingStepTimeFrom = moment(data.workingStepTime.startDate).startOf('day').valueOf()
          data.workingStepTimeTo = moment(data.workingStepTime.endDate).endOf('day').valueOf()
        }
        if (data.ticketDeadline.endDate) {
          data.ticketDeadlineFrom = moment(data.ticketDeadline.startDate).startOf('day').valueOf()
          data.ticketDeadlineTo = moment(data.ticketDeadline.endDate).endOf('day').valueOf()
        }
        delete data.createdTime
        delete data.workingStepTime
        delete data.ticketDeadline
        return data
      },
      async fetchData() {
        try {
          this.tbLoading = true
          const params = this.preareData()
          const response = await TicketService.fetchWork(params)
          if (response.code === 1000) {
            this.lists = response.data
            this.pagination.total = response.meta.total
          } else {
            this.showFailMx(response.message)
          }
        } catch (error) {
          console.log(error)
        } finally {
          this.tbLoading = false
          this.selectedTicket = []
        }
      },
      detailTicket(id) {
        const routeData = this.$router.resolve({ path: `/ticket/${id}` })
        window.open(routeData.href, '_blank')
      },
      closeModalRequestDevice() {
        this.$bvModal.hide('change-assignee')
        this.isShowModalRequestDevice = false
      },
      showModalRequestDevice(data) {
        this.dataId = {
          data,
          currentAssigneeId: this.search.userId,
        }
        this.isShowModalRequestDevice = true
        this.$nextTick(s => this.$bvModal.show('change-assignee'))
      },
      async updateInfo(data) {
        try {
          this.showLoading = true
          const params = {
            list: data,
          }
          const response = await TicketService.changeAssignee(params)
          if (response.code === 1000) {
            this.showSuccessMx('Chuyển người làm thành công!')
            this.closeModalRequestDevice()
            this.fetchData()
          } else {
            this.showFailMx(response.message)
          }
        } catch (error) {
          console.log(error)
        } finally {
          this.showLoading = false
        }
      },
      async getListTicketCategory() {
        try {
          let findGroup = {}
          this.dataTypeCode = []
          if (this.search.groupCode && this.search.groupCode != '') {
            findGroup = this.dataGroupCode.find(s => s.id === this.search.groupCode)
          }

          const params = {
            groupId: Object.keys(findGroup).length > 0 && findGroup.mapId ? findGroup.mapId : '',
          }

          const res = await TicketService.getListTicketCategory(params)
          if (res.code === 1000) {
            this.dataTypeCode = res.data.map(e => {
              return { id: e.code, text: e.name, mapId: e.id }
            })
          }
        } catch (error) {}
      },
      async getListTicketSubCategory() {
        try {
          let findType = {}
          this.dataSubTypeCode = []
          if (this.search.typeCode && this.search.typeCode != '') {
            findType = this.dataTypeCode.find(s => s.id === this.search.typeCode)
          }

          const params = {
            categoryId: Object.keys(findType).length > 0 && findType.mapId ? findType.mapId : '',
          }

          const res = await TicketService.getListTicketSubCategory(params)
          if (res.code === 1000) {
            this.dataSubTypeCode = res.data.map(e => {
              return { id: e.code, text: e.name, mapId: e.id }
            })
          }
        } catch (error) {}
      },
      onChangePage(page) {
        this.search.pageIndex = page
        this.fetchData()
      },
    },
  }
</script>
<style scoped>
  .c-poiter {
    cursor: pointer;
  }
</style>
